import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { SayDesignSystemComponent } from './say-design-system.component';
import { ButtonComponent } from './components/button/button.component';
import { BreakpointHelperComponent } from './components/breakpoint-helper/breakpoint-helper.component';
import { SpritesheetComponent } from './components/spritesheet/spritesheet.component';
import { BannerComponent } from './components/banner/banner.component';
import { AccessibilityToggleComponent } from './components/accessibility-toggle/accessibility-toggle.component';
import { ToggleBoxComponent } from './components/toggle-box/toggle-box.component';
import { HorizontalSliderComponent } from './components/horizontal-slider/horizontal-slider.component';
import { InputTelephoneComponent } from './components/input-telephone/input-telephone.component';
import { InputTelephoneDirective } from './directives/input-telephone/input-telephone.directive';
import { ToastComponent } from './components/toast/toast.component';

@NgModule({
  imports: [
      CommonModule,
      FormsModule
  ],
  declarations: [
    SayDesignSystemComponent,
    ButtonComponent,
    BreakpointHelperComponent,
    SpritesheetComponent,
    BannerComponent,
    AccessibilityToggleComponent,
    ToggleBoxComponent,
    HorizontalSliderComponent,
    InputTelephoneComponent,
    InputTelephoneDirective,
    ToastComponent
  ],

  exports: [
    SayDesignSystemComponent,
    ButtonComponent,
    BreakpointHelperComponent,
    SpritesheetComponent,
    BannerComponent,
    AccessibilityToggleComponent,
    ToggleBoxComponent,
    HorizontalSliderComponent,
    InputTelephoneComponent,
    ToastComponent
  ]
})
export class SayDesignSystemModule { }
